import { Component } from '@angular/core';
import { ICmsOutletBlockComponent } from '../outlet-block/icms-outlet-block.component';
@Component({
    selector: 'error-500',
    templateUrl: 'error-500.html',
    standalone: true,
    imports: [ICmsOutletBlockComponent]
})
export class Error500Component {}
